import { render, staticRenderFns } from "./PicBanner.vue?vue&type=template&id=5648626e&"
import script from "./PicBanner.vue?vue&type=script&lang=js&"
export * from "./PicBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports